import Council from "./TabPages/Council/Council";
import History from "./TabPages/History/History";
import KnowMore from "./TabPages/KnowMore/KnowMore";
import Vision from "./TabPages/Vision/Vision";
import Volunteer from "./TabPages/Volunteer/Volunteer";

export const TABS_DATA = [
  {
    label: "วิสัยทัศน์",
    component: <Vision />,
  },
  {
    label: "ประวัติความเป็นมา",
    component: <History />,
  },
  {
    label: "หนังสือที่ระลึก",
    component: <KnowMore />,
  },
  {
    label: "คณะกรรมการ",
    component: <Council />,
  },
  {
    label: "ทีมอาสาสมัคร",
    component: <Volunteer />,
  },
];
